<template>
  <table :style="styleObject" cellspacing="0" cellpadding="0" border="0">
    <colgroup>
      <col v-for="(column, columnIndex) in columns"
           :key="columnIndex"
           :width="setCellWidth(column, columnIndex, false)"/>
    </colgroup>
    <tbody :class="[prefixTableClass + '-tbody']">
      <template v-for="(row, rowIndex) in data">
        <t-table-row v-show="!row._isHidden"
                     :ref="`tableRow${rowIndex}`"
                     :key="(row._loopKey || `r${rowIndex}`)"
                     :prefix-table-class="prefixTableClass"
                     :tree-data="treeData"
                     :fixed="fixed"
                     :row="row"
                     :columns="columns"
                     :all-ellipsis="allEllipsis"
                     @click.native="$_onRowClick(row._index)"
                     @dblclick.native.stop="$_onRowDBLClick(row._index)"
                     @row-height-correction="rowHeightCorrection">
        </t-table-row>
        <template v-if="isExpandrow && !row._disableExpand">
          <tr v-show="row._isExpanded"
              :key="(row._loopKey || `exp-tr${rowIndex}`)"
              :class="prefixTableClass + '__row--expanded'">
            <td :colspan="columns.length" :id="`exp${rowIndex}`">
              <expand ref="expandRow" :key="(row._loopKey || `exp${rowIndex}`)" :row="row" :render="expandRender" :index="row._index"></expand>
            </td>
          </tr>
        </template>
      </template>
    </tbody>
  </table>
</template>
<script>
import TTableRow from './table-row.vue'
import Expand from './expand.js'
import Mixin from './mixin'

export default {
  name: 'TTableBody',
  components: {Expand, TTableRow},
  mixins: [Mixin],
  props: {
    prefixTableClass: String,
    styleObject: Object,
    columns: Array,
    data: Array, // rebuildData
    columnsWidth: Object,
    treeData: Object,
    fixed: {
      type: [Boolean, String],
      default: false
    },
    allEllipsis: Boolean
  },
  data() {
    return {
      heightInited: false
    }
  },
  computed: {
    isFloat() {
      return ['right', 'left'].includes(this.fixed)
    },
    expandList() {
      let data = this.data
      let count = data.length
      let list = []
      for (let i = 0; i < count; i++) {
        if (!data[i]._disableExpand) {
          list.push(data[i])
        }
      }
      return list
    },
    expandRender () {
      let render = function () {
        return ''
      }
      for (let i = 0; i < this.columns.length; i++) {
        const column = this.columns[i]
        if (column.type && column.type === 'expand') {
          if (column.render) render = column.render
        }
      }
      return render
    },
    isExpandrow () {
      return this.columns.some(cell => cell.type === 'expand')
    }
  },
  methods: {
    fixHeight(rowIndex) {
      if (this.isExpandrow && this.data[rowIndex]._isExpanded) {
        let el = document.getElementById(`exp${rowIndex}`)
        let warpHeight = el.offsetHeight
        if (el.children.length > 0) {
          el = el.children[0]
          let expanerHeight = el.offsetHeight
          el.style.height = `${expanerHeight}px`
          return warpHeight
        }
      }
      return -1
    },
    getRowClassName (index) {
      return this.$parent.rowClassName(this.data[index], index)
    },
    $_onRowClick (index) {
      this.$parent.clickRow(index)
    },
    $_onRowDBLClick (index) {
      this.$parent.dblclickRow(index)
    },
    toggleTreeNode (index, row) {
      const isHidden = !row._isOpenNode
      for (let i = index + 1; i < this.data.length; i++) {
        if (this.data[i]._indent > row._indent) {
          if (isHidden === true) { // 收起节点
            this.data[i]._isHidden = isHidden
            this.data[i]._isOpenNode = false
          } else {
            if (this.data[i]._indent === row._indent + 1) {
              this.data[i]._isHidden = isHidden
            }
          }
        } else {
          break
        }
      }
      this.$parent.toggleTreeNode(row, row._isOpenNode)
    },
    rowHeightCorrection (maxHeight, fixed, index) {
      this.$emit('row-height-correction', maxHeight, fixed, index)
    },
    setRowHeight (maxHeight, index) {
      let existExpander = !this.$el.querySelector(`exp${index}`)
      let rowcomp = this.$refs[`tableRow${index}`][0]
      let height = maxHeight
      if (this.isFloat === false) {
        if (rowcomp.$el.offsetHeight !== maxHeight) {
          rowcomp.$el.style.height = maxHeight + 'px'
        }
        if (existExpander && !this.data[index]._disableExpand) {
          height = this.fixHeight(index)
          if (height === -1) { // 如果没有折叠区域那么返回本行高度
            height = maxHeight
          } else {
            height += maxHeight
          }
        }
      } else {
        if (rowcomp.$el.offsetHeight !== maxHeight) {
          rowcomp.$el.style.height = maxHeight + 'px'
        }
      }
      return height
    }
  }
}
</script>



// WEBPACK FOOTER //
// table-body.vue?63eed494